import React from "react";
import PropTypes from "prop-types";

function SimpleUploadLink(props) {
  // Do NOT pass `value` to <input type="file"> (can break selection / onChange in React)
  const { labelText, name, id, disable, value, ...inputProps } = props;
  const inputId = id || name;
  let style = {
    cursor: "pointer",
    border: "0.25vh solid #1a337e",
    color: "#000",
    backgroundColor: "#fff",
    textTransform: "none",
    fontWeight: 500,
    fontSize: "clamp(1.4vh, 0.85vw, 1.7vh)",
    fontFamily: "'Montserrat', sans-serif",
    width: "calc(160 / 1920 * 100vw)",
    height: "4.8vh",
    borderRadius: "3vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center"
  };
  if (disable) style = {};
  return (
    <React.Fragment>
      <input
        style={{ display: "none" }}
        type="file"
        id={inputId}
        name={name}
        disabled={disable}
        {...inputProps}
      />
      <label htmlFor={inputId} style={style}>
        {labelText}
      </label>
    </React.Fragment>
  );
}
SimpleUploadLink.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  disable: PropTypes.bool,
};
export default SimpleUploadLink;
